import styled from 'styled-components';
import ReactSelect from 'react-select';
import typings from '@designSystem/typings';
import colors from '@designSystem/colors';

const StyledReactSelect = styled(ReactSelect)`
  & > div {
    ${typings.commonTyping}
    align-items: center;
    width: 100%;
    box-sizing: border-box;
    border-radius: 8px;
    border: 1.5px solid ${(props) => (props.error ? colors.red : colors.grey)};
  }
`;

export default StyledReactSelect;
